export default "__VITE_ASSET__79040dde__"